import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/free-solid-svg-icons';

function Student_Fee({setTC, stude_P}) {

 const [phone, setPhone] = useState()

  const no_pay = () =>
  {
    
  }

  const pay = () =>{
    if (!phone) {
     alert('please add number')
    } else {
      const loginData = {
         num: phone
      
       };
 
             // Send data to the PHP backend using fetch
             fetch('https://hosteladventures.site/PHP/MPESA/Real_est.php', {
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify(loginData)
             })
               .then(response => response.json())
               .then(data => {
                 // Handle response from backend (e.g., login success or failure)
                 console.log(data)
              
               })
               .catch(error => {
                 console.error('Error:', error);
               });
    }
  }

  return (
    <div  className='inner_TC_MAIN'>
    <div className='Main_MPESA_inner'>
      <FontAwesomeIcon icon={faMobile} className='phoneMpesa' />
      <p className='fee'>Pay a Accomodation booking/Appliction fee of Ksh 300 via Mpesa to finalize</p>

      <input placeholder='Add Mpesa Number, start with 254 not +254' onChange={(event) => setPhone(event.target.value)} />

      <div className='T_C_Buttons'>
       <button className='acc_BTN' onClick={pay}>pay</button>
       <button className='dec_BTN' onClick={no_pay}>don't pay</button>
      </div>
   </div>
   </div>
  )
}

export default Student_Fee